// extracted by mini-css-extract-plugin
export var more = "More-module--more--36a2d";
export var secondary = "More-module--secondary--6d2f9";